import { render, staticRenderFns } from "./PlacementRecommendTable.vue?vue&type=template&id=2a6750f8"
import script from "./PlacementRecommendTable.vue?vue&type=script&lang=js"
export * from "./PlacementRecommendTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports